import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { debug, deepCopy } from "../../utils";
import * as validationService from "./validationService";
import * as deviceService from "../deviceService";
import * as modalDataService from "./modalDataService";
import { DeviceStatus } from "../../vars";

function FetchConfigurationSection({ modalData }) {
    const [connected, setConnected] = useState(null);
    const [errorMessage, setErrorMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [multiDeviceDisable, setMultiDeviceDisable] = useState(false);
    const centralCredentialId = modalData.centralCredential?.id || null;

    useEffect(() => {
        validationService.initValidation("fetchConfig");
        return () => validationService.cleanValidation("fetchConfig");
    }, []);

    useEffect(() => {
        if (connected === false) {
            validationService.updateValidation(connected, "fetchConfig", "Not Connected");
        } else {
            validationService.updateValidation(connected, "fetchConfig");
        }
    }, [connected]);

    useEffect(() => {
        let ipString = modalData.mngtIpAddress;
        if (ipString && typeof ipString === "string") {
            ipString = ipString.trim();
            setMultiDeviceDisable(ipString.includes(",") || ipString.includes("-"));
        } else {
            setMultiDeviceDisable(false);
        }
    }, [modalData.mngtIpAddress]);

    useEffect(() => {
        setConnected(null);
        setErrorMessage("");
        modalDataService.changeConnectionStatus(DeviceStatus.UNKNOWN);
        validationService.initValidation("fetchConfig");
    }, [
        modalData.mngtIpAddress,
        modalData.port,
        modalData.connectionType,
        modalData.sshUsername,
        modalData.sshPassword,
        modalData.sshPasswordlessKey,
        modalData.winrmUsername,
        modalData.winrmPassword,
        modalData.apiUrl,
        modalData.apiUsername,
        modalData.apiPassword,
        modalData.apiKey,
        modalData.powerCliUsername,
        modalData.powerCliPassword,
        centralCredentialId
    ]);

    const onButtonClick = async () => {
        if (multiDeviceDisable) {
            return;
        }

        setLoading(true);
        setErrorMessage("");
        setConnected(null);

        const result = await deviceService.checkConnectivity(deepCopy(modalData));

        if (result.connected) {
            setConnected(true);
            modalDataService.changeConnectionStatus(DeviceStatus.CONNECTED);
        } else {
            setConnected(false);
            modalDataService.changeConnectionStatus(DeviceStatus.DISCONNECTED);
            setErrorMessage(result.output);
        }

        setLoading(false);
    };

    const stateClass = loading
        ? "is-testing"
        : connected === true
            ? "is-success"
            : connected === false
                ? "is-error"
                : "is-idle";

    return (
        <div className="modal-v2-step2-status-shell">
            {!multiDeviceDisable && (
                <div className={`modal-v2-step2-indicator ${stateClass}`}>
                    {loading ? (
                        <>
                            <div className="modal-v2-step2-indicator-track">
                                <span className="modal-v2-step2-indicator-dot is-testing" />
                                <span className="modal-v2-step2-indicator-line is-testing" />
                                <span className="modal-v2-step2-indicator-loader">
                                    <span className="modal-v2-step2-loader-ring" />
                                </span>
                                <span className="modal-v2-step2-indicator-line" />
                                <span className="modal-v2-step2-indicator-dot" />
                            </div>
                            <div className="modal-v2-step2-status-text is-testing">Testing Connection...</div>
                        </>
                    ) : connected === true ? (
                        <>
                            <div className="modal-v2-step2-indicator-track">
                                <span className="modal-v2-step2-indicator-dot is-success" />
                                <span className="modal-v2-step2-indicator-line is-success" />
                                <span className="modal-v2-step2-indicator-result is-success">
                                    <span className="modal-v2-step2-indicator-symbol">✓</span>
                                </span>
                                <span className="modal-v2-step2-indicator-line is-success" />
                                <span className="modal-v2-step2-indicator-dot is-success" />
                            </div>
                            <div className="modal-v2-step2-status-text is-success">Successfully Connected</div>
                        </>
                    ) : connected === false ? (
                        <>
                            <div className="modal-v2-step2-indicator-track">
                                <span className="modal-v2-step2-indicator-dot is-error" />
                                <span className="modal-v2-step2-indicator-line is-error" />
                                <span className="modal-v2-step2-indicator-result is-error">
                                    <span className="modal-v2-step2-indicator-symbol">×</span>
                                </span>
                                <span className="modal-v2-step2-indicator-line" />
                                <span className="modal-v2-step2-indicator-dot" />
                            </div>
                            <div className="modal-v2-step2-status-text is-error">Not Successfully Connected</div>
                        </>
                    ) : (
                        <div className="modal-v2-step2-idle-row">
                            <span className="modal-v2-step2-indicator-dot is-idle" />
                            <div className="modal-v2-step2-status-text is-idle">Ready to test connection</div>
                        </div>
                    )}
                </div>
            )}

            {!multiDeviceDisable && (
                <div className="modal-v2-step2-actions">
                    <button
                        type="button"
                        className={`btn modal-v2-btn modal-v2-btn-primary modal-v2-step2-test-btn ${loading ? "disabled" : ""}`}
                        onClick={onButtonClick}
                        disabled={loading}
                    >
                        {loading && <span className="modal-v2-step2-button-loader" />}
                        <span>{loading ? "Testing..." : "TEST CONFIGURATION"}</span>
                    </button>
                </div>
            )}

            {errorMessage && (
                <div className="modal-v2-step2-error-box">
                    {/* <div className="modal-v2-step2-error-label">Error message:</div> */}
                    <div className="modal-v2-step2-error-message">
                        {errorMessage}
                        {errorMessage.includes("401") && " (Invalid credentials)"}
                    </div>
                </div>
            )}
        </div>
    );
    
}

function mapStateToProps(state) {
    debug("FetchConfigurationSection mapStateToProps", state);
    const modalData = state.addDeviceModal;
    return {
        error: state.validation.fetchConfig,
        modalData: modalData
    };
}

export default connect(mapStateToProps)(FetchConfigurationSection);
